import { CodeFunction, PromptFunction } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import { StoreEnvironment } from '../Types/StoreTypes';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const connectorService = {
    saveConnector: async (urlPart: string, data: any): Promise<any> => {
        return requestClient.post<PromptFunction>(`/promptfunctions/${urlPart}`, data);
    },

    getPromptFunctionsByPage: (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query: string | null = null,
    ): Promise<{ data: { data: PromptFunction[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? 'demo' : ''}/promptfunctions/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getUserPromptFunctionsByPage: (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ): Promise<{ data: { data: PromptFunction[]; total: number } }> => {
        return requestClient
            .get('/promptfunctions/getuserfunctions', {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getConnectors: async (): Promise<{ data: PromptFunction[] }> => {
        return requestClient.get<PromptFunction[]>(`${resolveDemo() ? 'demo' : ''}/promptfunctions/get`);
    },

    getConnector: async (identifier: string): Promise<{ data: PromptFunction }> => {
        return requestClient.get<PromptFunction>(`${resolveDemo() ? 'demo' : ''}/promptfunctions/get/${identifier}`);
    },

    getCodeFunctions: async (): Promise<{ data: CodeFunction[] }> => {
        return requestClient.get<CodeFunction[]>(`/promptfunctions/getcodefunctions`);
    },

    deleteConnector: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/promptfunctions/delete/${identifier}`);
    },
};
